import { createContext, useContext } from 'react'

export const VideoContext = createContext()
export const useVideo = () => useContext(VideoContext)

const VideoProvider = ({ children, value }) => <VideoContext.Provider value={value}>{children}</VideoContext.Provider>

export default VideoProvider
